import React, { useEffect } from 'react';
import loadable from '@loadable/component';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchFeaturedLawyers } from './LandingPage.duck';

const CustomLandingPage = loadable(() =>
  import(/* webpackChunkName: "CustomLandingPage" */ './CustomLandingPage')
);

export const LandingPageComponent = ({ featuredLawyers, onFetchFeaturedLawyers }) => {
  useEffect(() => {
    onFetchFeaturedLawyers();
  }, []);

  return <CustomLandingPage featuredLawyers={featuredLawyers} />;
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { featuredLawyers } = state.LandingPage || {};
  return { pageAssetsData, inProgress, error, featuredLawyers: featuredLawyers || [] };
};

const mapDispatchToProps = dispatch => ({
  onFetchFeaturedLawyers: () => dispatch(fetchFeaturedLawyers()),
});

const LandingPage = compose(connect(mapStateToProps, mapDispatchToProps))(LandingPageComponent);

export default LandingPage;
